<template>
  <!-- 季度填报 | 季度填报详情 -->
  <div class="quarterlyFilingApplication">
    <commonHeader>
      <template v-if="isReadonly" #buttons>
        <!-- 召回 -->
        <el-button v-if="btnShowControl.showRecall" plain @click="recallBtn">召回修改</el-button>
        <!-- 驳回 -->
        <el-button v-if="btnShowControl.showReject" plain @click="agreeRejectBtn($t('btn.Rejected'))">驳回</el-button>
        <!-- 同意 -->
        <el-button v-if="btnShowControl.showAgree" plain @click="agreeRejectBtn($t('btn.Agree'))">同意</el-button>
      </template>
    </commonHeader>
    <!-- 基础信息 -->
    <BasicInformation ref="basicInformation" :is-readonly="isReadonly" :edit-echo-data="editEchoData" />
    <!-- 季度完成情况 -->
    <quarterlyCompletionStatus
      ref="quarterlyCompletionStatus"
      :available-quarters="availableQuarters"
      :weight-config="weightConfig"
      :target-config="targetConfig"
      :actual-config="actualConfig"
      :system-config="systemConfig"
      :indicator-type="indicatorType"
      :is-readonly="isReadonly"
      :edit-echo-data="editEchoData"
    />
    <div v-if="!isReadonly && !isLoading" class="btn-list">
      <el-button plain @click="backBtn">返回</el-button>
      <el-button type="primary" :loading="isSubmitting" @click="submitBtn">提交</el-button>
    </div>
    <!-- 审批弹窗 -->
    <approveDialog ref="approveDialog" @approveSubHandle="approveSubHandle" />
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader';
import BasicInformation from './components/basicInformation.vue';
import quarterlyCompletionStatus from './components/quarterlyCompletionStatus.vue';
import approveDialog from '../components/approveDialog.vue';
import { annualApplicationApi } from '../service';
import { isNotEmpty } from '@/utils/utils';
export default {
  components: {
    commonHeader,
    BasicInformation,
    quarterlyCompletionStatus,
    approveDialog
  },
  data () {
    return {
      availableQuarters: [], // ['q1', 'q2'], // 可选季度列
      isDetails: false,
      weightConfig: { weightQuantity: undefined, weightCoverage: undefined, weightLeads: undefined, weightCost: undefined }, // 权重配置
      targetConfig: {
        // 各字段示例 { q1: 20, q2: 20, ..., annual: 80 },
        offlineEvents: {},
        hqEvents: {},
        templateEvents: {},
        livestreamEvents: {},
        contents: {},
        coverage: {},
        leadsNew: {},
        projects: {},
        amount: {},
        cpml: {},
        cpsql: {}
      }, // 目标值配置
      actualConfig: {
        // 示例 { q1: 22, q2: 24, ..., annual: 80 },
        offlineEvents: {},
        hqEvents: {},
        templateEvents: {},
        livestreamEvents: {},
        contents: {},
        coverage: {},
        leadsNew: {},
        projects: {},
        amount: {},
        cpml: {},
        cpsql: {}
      }, // 实际值配置
      systemConfig: {
        // 系统统计示例 { q1: 30, annual: 120 }
        offlineEvents: {},
        hqEvents: {},
        templateEvents: {},
        livestreamEvents: {},
        contents: {},
        coverage: {},
        leadsNew: {},
        projects: {},
        amount: {},
        cpml: {},
        cpsql: {}
      }, // 系统统计配置
      indicatorType: '', // 指标类型
      annualPlanId: '',
      quarter: '',
      id: '',
      editEchoData: {}, // 编辑回显数据
      isLoading: true, // 是否正在加载
      isSubmitting: false // 是否正在提交
    };
  },
  computed: {
    // 按钮显示控制
    btnShowControl () {
      const userInfo = this.$store.state.userInfo;
      if (!isNotEmpty(this.editEchoData)) {
        return {
          showRecall: false,
          showAgree: false,
          showReject: false,
          showSubmit: true
        };
      }
      const { status, submitUserName, allowApprove } = this.editEchoData;
      // 申请人是否是当前用户
      const isOperate = submitUserName === userInfo.sysUser.userName;
      const btns = {
        showRecall: false, // 召回
        showAgree: false, // 同意
        showReject: false, // 驳回
        showSubmit: false // 提交
      };
      // 0-未开始 1-待完成 2-审批中 3- 4-驳回 5-召回
      switch (status) {
        case 2:
          // 申请人是当前用户，才能召回
          btns.showRecall = isOperate;
          btns.showAgree = allowApprove;
          btns.showReject = allowApprove;
          break;
        case 3:
          // 申请人是当前用户，才能提交
          btns.showSubmit = isOperate;
          break;
        case 4:
          // 申请人是当前用户，才能提交
          btns.showSubmit = isOperate;
          break;
        case 5:
          // 申请人是当前用户，才能提交
          btns.showSubmit = isOperate;
          break;
        default:
          break;
      }
      return btns;
    },
    isReadonly () {
      // 回显数据不存在，说明是新建，非只读
      // 状态为待完成，非只读
      if (!isNotEmpty(this.editEchoData) || this.editEchoData.status === 1) {
        return false;
      }
      // 详情页，或非申请人，或已废弃，或已驳回，或已召回，都为只读
      return this.isDetails ? true : !this.btnShowControl.showSubmit;
    }

  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      const quarter = this.$route.query.quarter;
      this.annualPlanId = this.$route.query.annualPlanId;
      this.id = this.$route.query.id;
      this.availableQuarters = [quarter];
      this.quarter = quarter;
      this.isDetails = this.$route.path === '/quarterlyFilingDetails';
      this.getQuarterlyFilingDetails();
    },
    getQuarterlyFilingDetails () {
      this.isLoading = true;
      const params = {
        quarterReportId: this.id,
        annualPlanId: this.annualPlanId
      };
      annualApplicationApi.quarterDetail(params).then(res => {
        this.isLoading = false;
        if (res.status === '200') {
          const data = JSON.parse(JSON.stringify(res.data));
          this.indicatorType = data.planType;
          this.weightConfig = {
            weightQuantity: data.weightQuantity,
            weightCoverage: data.weightCoverage,
            weightLeads: data.weightLeads,
            weightCost: data.weightCost
          }; // 年度权重入参配置
          this.editEchoData = data;
          Object.keys(this.actualConfig).forEach(key => {
            const annualTarget = data.annualIndicators[key + 'Target']; // 年度目标
            const quarterTarget = data.quarterIndicators[key + 'Target']; // 季度目标
            const annualActual = data.annualIndicators[key + 'Actual']; // 年度实际
            const quarterActual = data.quarterIndicators[key + 'Actual']; // 季度实际
            const annualSystem = data.annualIndicators[key + 'System']; // 年度系统统计
            const quarterSystem = data.quarterIndicators[key + 'System']; // 季度系统统计
            this.$set(this.targetConfig[key], 'annual', annualTarget); // 遍历季度年度目标设置入参格式化
            this.$set(this.targetConfig[key], this.quarter, quarterTarget); // 遍历季度目标设置入参格式化
            this.$set(this.actualConfig[key], 'annual', annualActual); // 年度实际情况以已完成季度汇总为基准
            this.$set(this.actualConfig[key], 'annualResult', annualActual); // 记录年度实际的原始值，便于后续叠加当前季度
            this.$set(this.actualConfig[key], this.quarter, quarterActual); // 遍历季度实际完成情况入参格式化
            this.$set(this.systemConfig[key], 'annual', annualSystem); // 遍历年度系统统计入参格式化
            this.$set(this.systemConfig[key], this.quarter, quarterSystem); // 遍历季度系统统计入参格式化
          });
        }
      });
    },
    // 返回按钮
    backBtn () {
      this.$router.push({
        path: '/annualMarketingPlan'
      });
    },
    // 废弃按钮
    discardBtn () {
      this.$confirm('确定废弃该年度规划?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          annualPlanId: this.id
        };
        annualApplicationApi.annualPlanAbandon(params).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.$router.push('/annualMarketingPlan');
          }
        });
      }).catch(() => {});
    },
    // 提交按钮
    submitBtn () {
      this.$refs.basicInformation.validateHandler().then(valid => {
        if (valid) {
          const basicParams = JSON.parse(JSON.stringify(this.$refs.basicInformation.formData)); // 基础信息
          delete basicParams.submitUser; // 删除冗余字段
          delete basicParams.submitTime; // 删除冗余字段
          this.$refs.quarterlyCompletionStatus.validateHandler().then((valid) => {
            if (valid) {
              this.isSubmitting = true;
              const quarterParams = this.$refs.quarterlyCompletionStatus.getQuarterParamsValue(); // 季度实际情况入参
              const params = {
                ...basicParams, // 年度规划基础信息
                ...quarterParams, // 年度规划指标信息
                annualPlanId: this.annualPlanId
              };
              if (this.$route.path === '/quarterlyFilingApplication' && this.editEchoData.status !== 1) {
                params.id = this.id;
              }
              const requestUrl = this.editEchoData.status === 1 ? annualApplicationApi.quarterSubmit : annualApplicationApi.quarterEdit;
              requestUrl(params).then(res => {
                this.isSubmitting = false;
                if (res.status === '200') {
                  this.$message.success('提交成功');
                  this.$router.push('/annualMarketingPlan');
                }
              });
            }
          });
        }
      });
    },
    // 同意 | 拒绝按钮
    agreeRejectBtn (val) {
      this.$refs.approveDialog.init({
        type: val,
        visible: true
      });
    },
    // 审批提交
    approveSubHandle (parameter) {
      const { reason, type } = parameter;
      let requestUrl = '';
      if (type === '同意') {
        requestUrl = annualApplicationApi.quarterApprove;
      } else if (type === '驳回') {
        requestUrl = annualApplicationApi.quarterReject;
      }
      requestUrl({
        comment: reason,
        quarterReportId: this.id
      }).then(res => {
        if (res.status === '200') {
          this.$message.success(this.$t('general.OperSucc'));
          this.init();
        }
      });
    },
    // 撤回修改
    recallBtn () {
      this.$confirm('确定召回修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          quarterReportId: this.id
        };
        annualApplicationApi.quarterRecall(params).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.$router.push('/annualMarketingPlan');
          }
        });
      }).catch(() => {});
    }
  }
};
</script>
<style scoped>
.btn-list {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}
</style>
